// @flow
import React, { Component } from 'react';
import { TouchableOpacity, TextInput, View } from 'react-native';
import Icon from '../Icon';

import theme from '../../../theme-config';
import RtlAwareStyleSheet from '../../../lib/rtl-aware-stylesheet';

function getStyles() {
  return RtlAwareStyleSheet.create({
    text: {
      fontFamily: theme.fontFamily,
      rtlAware: {
        textAlign: 'left',
      },
      flex: 1,
    },
    inputContainer: {
      flexDirection: 'row',
      alignItems: 'center',
    },
    clearButton: {
      padding: 5,
      backgroundColor: 'rgb(155,155,155)',
      borderRadius: 15,
      alignItems: 'center',
      justifyContent: 'center',
    },
  });
}

class TripicaTextInput extends Component<Props> {
  styles = getStyles();
  _root: any;

  setNativeProps(nativeProps: any) {
    this._root.setNativeProps(nativeProps);
  }

  render() {
    const styles = this.styles;
    const { onClearText, ...props } = this.props;

    return (
      <View style={styles.inputContainer}>
        {
          /* $FlowFixMe Since TextInput can accept a lot more props, we cannot convert this.props to exact type (customization) even though it checks its exactness */
          <TextInput
            {...props}
            ref={component => {
              this._root = component;
            }}
            style={[styles.text, this.props.style]}
            value={this.props.value}
          />
        }
        {onClearText && !!this.props.value && (
          <TouchableOpacity style={styles.clearButton} onPress={onClearText}>
            <Icon name="cross" size={12} color="white" />
          </TouchableOpacity>
        )}
      </View>
    );
  }
}

type Props = {
  autoCorrect?: boolean,
  editable?: boolean,
  onChangeText?: Function,
  onClearText?: Function,
  onFocus?: Function,
  onSelectionChange?: Function,
  onSubmitEditing?: Function,
  placeholder?: string,
  //replace by ReturnKeyTypeOptions imported from react native once migration done
  returnKeyType?:
    | 'default'
    | 'done'
    | 'emergency-call'
    | 'go'
    | 'google'
    | 'join'
    | 'next'
    | 'none'
    | 'previous'
    | 'route'
    | 'search'
    | 'send'
    | 'yahoo',
  selection?:
    | ?$ReadOnly<{|
        end?: number,
        start: number,
      |}>
    | null,
  selectTextOnFocus?: boolean,
  style: any,
  testID?: string,
  underlineColorAndroid?: string,
  value: string,
};

export default TripicaTextInput;
